import React from 'react';
import styled from 'styled-components';
import em from 'polished/lib/helpers/em';
import { ContentContainer } from "@flow/components/ui";

const TextLiftContainer = styled.div`
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
  padding-bottom: 30px;
  
  ${ContentContainer} {
    -webkit-columns: 2 300px;
    -moz-columns: 2 300px;
    columns: 2 300px;
    -webkit-column-gap: 30px;
    -moz-column-gap: 30px;
    column-gap: 30px;
  }
`;

const Title = styled.h2`
  text-align: center;
  font-size: 5.4em;
  margin: ${em(4, 5.4)} auto; 
  padding: ${em(1.2, 5.4)} ${em(2.2, 5.4)};
`;

interface Props {
  content: any;
}

class TextLift extends React.Component<Props> {
  render() {

    const {
      content
    } = this.props;

    return (
      <TextLiftContainer>
        <Title>
          {content.title}
        </Title>
        <ContentContainer dangerouslySetInnerHTML={{ __html: content.text }}/>
      </TextLiftContainer>
    )
  }
}

export default TextLift;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/text-lift/TextLift.tsx